import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useText } from "@/lib/useText";
import { useContent } from "@/context/ContentContext";

export function StaffOnline() {
  const [data, setData] = useState(null);
  const t = useText();
  const hidden = !!useContent().content?.staff?.hidden;

  useEffect(() => {
    if (hidden) return undefined;
    let alive = true;
    const load = () => api.get("/staff/online").then(({ data: d }) => alive && setData(d)).catch(() => {});
    load();
    const id = setInterval(load, 20000);
    return () => { alive = false; clearInterval(id); };
  }, [hidden]);

  if (hidden || !data?.available || !data.total) return null;
  const online = data.online > 0;
  return (
    <>
      <div className="hairline" />
      <div className="flex items-center justify-between gap-6" data-testid="staff-online">
        <div className="flex items-center gap-2.5">
          <ShieldCheck size={14} className="text-eden-turquoise" aria-hidden="true" />
          <p className="font-mono text-[11px] uppercase tracking-widest text-eden-muted">{t("status_staff")}</p>
        </div>
        <p className="flex items-center gap-2 font-display text-sm font-semibold text-eden-text">
          <span className={`h-2 w-2 rounded-full ${online ? "bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.9)]" : "bg-eden-muted/40"}`} aria-hidden="true" />
          <span data-testid="staff-online-value">{data.online}</span>
          <span className="text-xs font-normal text-eden-muted">/ {data.total} online</span>
        </p>
      </div>
    </>
  );
}
